import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { states } from "../common/IndianStates";
import { droneEntrepreneur } from "../../services/FormServies";
import { ToastContainer, toast } from "react-toastify";
import FormConfirmPopUp from "../common/FormConfirmPopUp";

const EntrepreneurForm = () => {
  const [popUp, setPopUp] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contactNumber: "",
    dateOfBirth: "",
    aadharNumber: "",
    state: "",
    city: "",
    educationalQualification: "",
    collegeName: "",
    previousPlaceOfWork: "",
    currentPlaceOfWork: "",
    experience: "",
    currentDesignation: "",
  });

  const today = new Date();
  const formattedToday = today.toISOString().split("T")[0]; // Format: YYYY-MM-DD

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "dateOfBirth") {
      const inputDate = new Date(value);
      if (inputDate > today) {
        toast.error("Future dates are not allowed.");
        setFormData({ ...formData, dateOfBirth: "" });
      } else {
        setFormData({ ...formData, dateOfBirth: value });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    droneEntrepreneur(formData).then((res) => {
      if (res?.status === "success") {
        setPopUp(true);
        setFormData({
          name: "",
          email: "",
          contactNumber: "",
          dateOfBirth: "",
          aadharNumber: "",
          state: "",
          city: "",
          educationalQualification: "",
          collegeName: "",
          previousPlaceOfWork: "",
          currentPlaceOfWork: "",
          experience: "",
          currentDesignation: "",
        });
      } else {
        toast.error(res?.message);
      }
    });
  };

  return (
    <div className="pb-5">
      {popUp && (
        <FormConfirmPopUp
          setPopUp={setPopUp}
          para="Thank you for submitting your data. We have received your information and will connect with you shortly."
        />
      )}
      {/* <ToastContainer /> */}
      <div className="container bg-white">
        <div className="p-md-5 p-4 rounded-4 bg-white">
          <h4 className="fs_26 fw-bold ff_inter color_blue">Apply Now</h4>
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
                <label className="fs_16 ff_inter fw-medium color_darkgray">Name<span style={{color:"red"}}> *</span></label>
                <input
                  className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
                <label className="fs_16 ff_inter fw-medium color_darkgray">Email<span style={{color:"red"}}> *</span></label>
                <input
                  className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
                <label className="fs_16 ff_inter fw-medium color_darkgray">Contact Number<span style={{color:"red"}}> *</span></label>
                <input
                  className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                  type="text" // Changed to "text"
                  name="contactNumber"
                  value={formData.contactNumber}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, ""); // Allow only numbers
                    if (value.length <= 10) {
                      setFormData({ ...formData, contactNumber: value });
                    }
                  }}
                  maxLength={10} // Limit to 10 digits
                  required
                />
              </div>
              <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
                <label className="fs_16 ff_inter fw-medium color_darkgray">Date Of Birth <span style={{color:"red"}}> *</span></label>
                <input
                  className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                  type="date"
                  name="dateOfBirth"
                  value={formData.dateOfBirth}
                  onChange={handleChange}
                  max={formattedToday} // Prevent future dates
                  required
                />
              </div>
              {/* <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
                <label className="fs_16 ff_inter fw-medium color_darkgray">Aadhaar Number <span style={{color:"red"}}> *</span></label>
                <input
                  className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                  type="text" // Changed to "text" for uniformity
                  name="aadharNumber"
                  value={formData.aadharNumber}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, ""); // Allow only numbers
                    setFormData({ ...formData, aadharNumber: value });
                  }}
                  required
                />
              </div> */}
              <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
                <label className="fs_16 ff_inter fw-medium color_darkgray" htmlFor="state">State<span style={{color:"red"}}> *</span></label>
                <Form.Select
                  name="state"
                  className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                  value={formData.state}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select State</option>
                  {states.map((value, index) => (
                    <option key={index} value={value}>
                      {value}
                    </option>
                  ))}
                </Form.Select>
              </div>
              <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
                <label className="fs_16 ff_inter fw-medium color_darkgray">City <span style={{color:"red"}}> *</span></label>
                <input
                  className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
                <label className="fs_16 ff_inter fw-medium color_darkgray">Educational Qualification <span style={{color:"red"}}> *</span></label>
                <input
                  className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                  type="text"
                  name="educationalQualification"
                  value={formData.educationalQualification}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
                <label className="fs_16 ff_inter fw-medium color_darkgray">College Name<span style={{color:"red"}}> *</span></label>
                <input
                  className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                  type="text"
                  name="collegeName"
                  value={formData.collegeName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
                <label className="fs_16 ff_inter fw-medium color_darkgray">
                  Previous Place of Work <span className="fs_11">(NA if not applicable)</span>
                </label>
                <input
                  className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                  type="text"
                  name="previousPlaceOfWork"
                  value={formData.previousPlaceOfWork}
                  onChange={handleChange}
                />
              </div>
              <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
                <label className="fs_16 ff_inter fw-medium color_darkgray">
                  Current Place of Work <span className="fs_11">(NA if not applicable)</span>
                </label>
                <input
                  className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                  type="text"
                  name="currentPlaceOfWork"
                  value={formData.currentPlaceOfWork}
                  onChange={handleChange}
                />
              </div>
              <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
                <label className="fs_16 ff_inter fw-medium color_darkgray" htmlFor="experience">Experience<span style={{color:"red"}}> *</span></label>
                <Form.Select
                  name="experience"
                  className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                  value={formData.experience}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select</option>
                  <option value="College student">College student</option>
                  <option value="Fresher">Fresher</option>
                  <option value="1-2 years">1-2 years</option>
                  <option value="2-5 years">2-5 years</option>
                  <option value="5-10 years">5-10 years</option>
                  <option value="10-20 years">10-20 years</option>
                  <option value="Above 20 Years">Above 20 Years</option>
                </Form.Select>
              </div>
              <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
                <label className="fs_16 ff_inter fw-medium color_darkgray">Current Designation</label>
                <input
                  className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                  type="text"
                  name="currentDesignation"
                  value={formData.currentDesignation}
                  onChange={handleChange}
                />
              </div>
            </div>

            <button
              className="bg_darkblue1 border-0 rounded-2 fs_20 mt-5 fw-semibold text-white px-4 py-2"
              type="submit"
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EntrepreneurForm;
